import $ from 'jquery'
import fc from 'fullcalendar'
import 'fullcalendar/dist/fullcalendar.css'

export default function (selector, options = {}) {
  if (!options.header) {
    options.header = {
      left: 'prev,next today',
      center: 'title',
      right: 'month,agendaWeek,agendaDay',
    }
  }

  const calendar = new fc.Calendar($(selector), options)
  calendar.render()
}



// WEBPACK FOOTER //
// ./src/frontend/calendar.js